import React from 'react';

export function ExternalLink({ link, className = '', children }) {
    return (
        <a className={`legal-board-link ${className}`} href={link.url} target="_blank" rel="noopener noreferrer">
            {children || link.label}
            <i className="fas fa-external-link-alt legal-board-link-icon" aria-hidden="true"></i>
        </a>
    );
}

export function StatusPill({ tone = 'neutral', children }) {
    return <span className={`legal-board-pill legal-board-pill-${tone}`}>{children}</span>;
}

export function StateCorrection({ id, label, description, onClick, disabled = false }) {
    return (
        <div className="legal-board-state-correction">
            <button type="button" className="legal-board-button legal-board-revert-button" onClick={onClick} disabled={disabled} aria-describedby={`${id}-description`}>
                <svg width="16" height="16" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                    <path d="M7 3 3 7l4 4M3 7h9a5 5 0 0 1 0 10H9" />
                </svg>
                {label}
            </button>
            <p id={`${id}-description`} className="legal-board-muted">{description}</p>
        </div>
    );
}

/**
 * Accessible accordion item: a button with aria-expanded plus a conditionally
 * rendered panel. Used for everything that is secondary (how-to guides,
 * official links, procedures) so screens only show what is needed.
 */
export function Disclosure({ id, summary, open, onToggle, children, className = '', badge = null }) {
    return (
        <div className={`legal-board-disclosure ${open ? 'open' : ''} ${className}`}>
            <button type="button" className="legal-board-disclosure-summary" aria-expanded={open} aria-controls={id} onClick={onToggle}>
                <i className={`fas fa-chevron-${open ? 'down' : 'right'}`} aria-hidden="true"></i>
                <span className="legal-board-disclosure-label">{summary}</span>
                {badge}
            </button>
            {open ? <div id={id} className="legal-board-disclosure-body">{children}</div> : null}
        </div>
    );
}
